import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { productExportWarehouseBusiness } from "api/bussiness/product/product-export-warehouse-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { createProductOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { observer } from "mobx-react-lite";
import { IUpdateProductGoodsIssue } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateProductGoodsIssueSchema } from "./schema";

export const UpdateProductGoodsIssue = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsIssueStore: {
        openEdit,
        getProductGoodsIssue,
        productGoodsIssueDetail,
        pagination,
        setProp,
      },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
    setDefaults,
  } = useForm<IUpdateProductGoodsIssue>(getUpdateProductGoodsIssueSchema(), {
    id: productGoodsIssueDetail?.id,
    exportDate: productGoodsIssueDetail?.exportDate,
    items: [],
  });

  useEffect(() => {
    if (productGoodsIssueDetail) {
      setDefaults({
        id: productGoodsIssueDetail?.id,
        exportDate: productGoodsIssueDetail?.exportDate,
        items: productGoodsIssueDetail.items.map((x) => ({
          id: x.id,
          productId: x.productId,
          note: x.note,
          quantity: x.quantity,
        })),
      });

      if (
        productGoodsIssueDetail.items &&
        productGoodsIssueDetail.items.length > 0
      ) {
        getControl("items").children.forEach((row: IControl[]) => {
          const idCtr = row.filter((x) => x.name === "id")?.[0];
          const data = productGoodsIssueDetail.items.filter(
            (x) => idCtr && x.id === idCtr.value
          )?.[0];

          const productIdCtr = row.filter((x) => x.name === "productId")?.[0];
          if (productIdCtr && data?.product) {
            productIdCtr.setProp("optionItems", [
              {
                label: createProductOptionLabel(data.product),
                value: data.product?.id,
              },
            ]);
          }
        });
      }
    }
  }, [
    controls,
    getControl,
    productGoodsIssueDetail,
    productGoodsIssueDetail?.id,
    productGoodsIssueDetail?.exportDate,
    productGoodsIssueDetail?.items,
    setDefaults,
  ]);

  const saveHandler = useCallback(
    async (data: IUpdateProductGoodsIssue) => {
      try {
        if (!productGoodsIssueDetail?.id) return;
        await productExportWarehouseBusiness.update(
          productGoodsIssueDetail?.id,
          data
        );
        await getProductGoodsIssue({
          filter: pagination.filter,
          maxResultCount: pagination.itemsPerPage,
          skipCount: pagination.skipCount,
        });
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [
      getProductGoodsIssue,
      pagination.filter,
      pagination.itemsPerPage,
      pagination.skipCount,
      productGoodsIssueDetail?.id,
      setProp,
    ]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa xuất kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              controlSpacing={2}
              children={itemsControl}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
